const FORBIDDEN_CLIENT_IDENTITY_FIELDS = Object.freeze([
  "client",
  "clientId",
  "clientIref",
  "qr",
  "qrCode",
  "promoDirectQrCode",
]);

const DISABLED_BENEFIT_FIELDS = Object.freeze([
  "promoClaim",
  "promotionClaim",
  "promoDirect",
  "promotionDirect",
  "promoValue",
  "voucherClaim",
  "voucherValue",
  "voucherValueWithoutVAT",
  "useClientCredit",
  "useClientCreditWithoutVAT",
]);

export const CLIENT_CHECKOUT_CAPABILITIES = Object.freeze({
  authenticatedOrderIdentity: true,
  promotionClaimSelection: false,
  directBenefitSelection: false,
  voucherSelection: false,
  clientCredit: false,
  benefitStacking: false,
});

function withoutFields(value, blockedFields) {
  if (Array.isArray(value)) {
    return value.map((entry) => withoutFields(entry, blockedFields));
  }
  if (!value || typeof value !== "object") return value;
  return Object.entries(value).reduce((result, [key, entry]) => {
    if (!blockedFields.has(key)) {
      result[key] = withoutFields(entry, blockedFields);
    }
    return result;
  }, {});
}

/**
 * The current authenticated web checkout intentionally reuses the proven
 * anonymous order shape. Client ownership comes only from the bearer token.
 * Benefit/credit mapping stays disabled until the server can provide an
 * authoritative quote for its runtime exchange, limits and rounding rules.
 */
export function adaptAuthenticatedOrderPayload(payload) {
  if (containsClientBenefitFields(payload)) {
    throw new Error(
      "Client benefit and credit fields are disabled for web checkout"
    );
  }
  return withoutFields(payload, new Set(FORBIDDEN_CLIENT_IDENTITY_FIELDS));
}

export function containsClientBenefitFields(payload) {
  const blocked = new Set(DISABLED_BENEFIT_FIELDS);
  const visit = (value) => {
    if (Array.isArray(value)) return value.some(visit);
    if (!value || typeof value !== "object") return false;
    return Object.entries(value).some(
      ([key, entry]) => blocked.has(key) || visit(entry)
    );
  };
  return visit(payload);
}
